import { validateImageFile, validateImageUrl } from '../../../image-validations';
import { getFileInformation } from '../../../image-validations/helpers';
import { GlovoInvalidImageSourceError } from '../../../types';
import { uploadImageToProvider, uploadImageUrlToProvider } from './upload-api';
export const handleUrlSource = async (source, options) => {
    const { success, error } = validateImageUrl(source);
    if (!success)
        throw new GlovoInvalidImageSourceError('Image URL validations failed.', [
            error,
        ]);
    return uploadImageUrlToProvider(source, options);
};
export const handleFileSource = async (source, options) => {
    const file = source instanceof Blob ? new File([source], 'source', { type: source.type }) : source;
    const { success, errors } = await validateImageFile(file, options);
    if (!success) {
        const fileInformation = await getFileInformation(file);
        throw new GlovoInvalidImageSourceError('Image file validations failed.', errors, fileInformation);
    }
    return uploadImageToProvider(file, options);
};
//# sourceMappingURL=upload-handlers.js.map